export default {
  clean: () => import("/app/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  public: () => import("/app/layouts/public.vue").then(m => m.default || m)
}